import React, {useState} from 'react';
import {
  GxButton,
  GxCheckbox,
  GxIcon,
  GxInput, GxMenuItem,
  GxSelect,
} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import DatePicker from 'react-multi-date-picker';
import CalendarInput from '../../components/CalendarInput';
import styles from './styles/index.module.scss'
import {PlusIcon} from '../../assets';

const CreateCertificate = () => {
  const [tabGroups, setTabGroups] = useState<Record<string, any>>({
    parametersTab:{status:false},
    otherTab: {status: false},
    repeatTab: {status: false},
    additionalTab: {status: false},
  })
  const handleClickTab = (name:string) =>{
    setTabGroups({
      ...tabGroups,
      [name]: {status:!tabGroups[name].status}
    })
  }
  const cn = cnBind.bind(styles);
  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['header--subtitle']}>Добавить сертификат</div>
        <div className={styles['actions']}>
          <div className={styles['actions--status']}>Номер-серия:XBSF32SD</div>
          <div className={styles['actions--group-btn']}>
            <GxButton className={styles['btn--actions']}>Отмена</GxButton>
            <GxButton className={styles['btn--actions']}>Сохранить</GxButton>
          </div>
        </div>
      </div>
      <div className={styles['main']}>
        <div className={styles['main--left-block']}>
          <div className={styles['form']}>
            <div className={styles['form--item']}>
              <GxInput label='Название:' className={styles['form--input']}/>
            </div>
            <div className={styles['form--container']}>
              <div className={cn(styles['form--item'], styles['form--item__group'])}>
                <GxSelect
                  label='Статус:'
                  className={cn(styles['form--input'], styles['form--input__max-width'])}
                  value='option-1'
                >
                  <GxMenuItem value="option-1">Действителен</GxMenuItem>
                  <GxMenuItem value="option-2">Закрыт</GxMenuItem>
                  <GxMenuItem value="option-3">Option 3</GxMenuItem>
                </GxSelect>
                <GxInput
                  label='Цена:'
                  className={cn(styles['form--input'], styles['form--input__max-width'], styles['form--input__order'])}
                />
              </div>
            </div>
            <div className={styles['form--container']}>
              <div className={cn(styles['form--item'], styles['form--item__group'])}>
                <GxInput
                  label='Партия:'
                  className={cn(styles['form--input'], styles['form--input__max-width'])}
                />
                <div className={cn( styles['calendar'])}>
                  <span className={cn(styles['calendar__label'])}>Действителен до:</span>
                  <DatePicker
                    render={<CalendarInput/>}
                  />
                </div>
              </div>
            </div>
            <div className={styles['form--container']}>
              <div className={styles['form--item']}>
                <GxInput label='Покупатель:' className={styles['form--input']}/>
              </div>
              <GxButton className={styles['btn']}><GxIcon className={styles['btn--icon']} src={PlusIcon}/></GxButton>
            </div>
            <div className={styles['form--container']}>
              <div className={styles['form--item']}>
                <GxInput label='Контрагент:' className={styles['form--input']}/>
              </div>
              <GxButton className={styles['btn']}><GxIcon className={styles['btn--icon']} src={PlusIcon}/></GxButton>
            </div>
            <div className={styles['form--item']}>
              <GxSelect label='Источник продаж:' className={styles['form--input']}/>
            </div>
          </div>
        </div>
        <div className={styles['main--right-block']}>
          <div className={cn({
            'tab-group':true,
            'tab-group--active': tabGroups.parametersTab.status
          })}>
            <div className={styles['tab-group--container']}>
              <h2>Параметры</h2>
              <p className={styles['tab-group--action']} onClick={()=>handleClickTab('parametersTab')}>{tabGroups.parametersTab.status ? 'Свернуть':'Развернуть'}</p>
            </div>
            <div className={cn(styles['form'], styles['tab-group--item'])}>
              <div className={styles['form--item']}>
                <GxSelect label='Контрагент:' className={cn(styles['form--input'], styles['form--input__wrap'])}/>
              </div>
              <div className={styles['form--container']}>
                <div className={styles['form--item']}>
                  <GxInput label='Тариф труба:' className={cn(styles['form--input'], styles['form--input__wrap'],styles['form--input__right-block'])}/>
                </div>
                <GxButton className={styles['btn']}><GxIcon className={styles['btn--icon']} src={PlusIcon}/></GxButton>
              </div>
              <div className={styles['form--container']}>
                <div className={styles['form--item']}>
                  <GxInput label='Тариф волна:' className={cn(styles['form--input'], styles['form--input__wrap'],styles['form--input__right-block'])}/>
                </div>
                <GxButton className={styles['btn']}><GxIcon className={styles['btn--icon']} src={PlusIcon}/></GxButton>
              </div>
              <div className={styles['form--container']}>
                <div className={cn(styles['form--item'], styles['form--item__group'],styles['form--item__right-block'])}>
                  <GxInput
                    label='Участники (полет):'
                    className={cn(styles['form--input'],styles['form--input__min-width'],styles['form--input__wrap'])}
                  />
                  <GxInput
                    label='Использовано:'
                    className={cn(styles['form--input'],styles['form--input__min-width'],styles['form--input__wrap'])}
                  />
                </div>
              </div>
              <div className={styles['form--container']}>
                <div className={cn(styles['form--item'], styles['form--item__group'],styles['form--item__right-block'])}>
                  <GxInput
                    label='Участники (волна):'
                    disabled
                    className={cn(styles['form--input'],styles['form--input__min-width'],styles['form--input__wrap'])}
                  />
                  <GxInput
                    label='Использовано:'
                    disabled
                    className={cn(styles['form--input'],styles['form--input__min-width'],styles['form--input__wrap'])}
                  />
                </div>
              </div>
              <div className={styles['form--container']}>
                <div className={cn(styles['form--item'], styles['form--item__group'],styles['form--item__right-block'])}>
                  <GxInput
                    label='Тариф труба, мин.'
                    className={cn(styles['form--input'],styles['form--input__min-width'],styles['form--input__wrap'])}
                  />
                  <GxInput
                    label='Тариф волна, мин.'
                    className={cn(styles['form--input'],styles['form--input__min-width'],styles['form--input__wrap'])}
                  />
                </div>
              </div>
              <GxCheckbox className={styles['form--type']} checked={false}>Интсруктор:</GxCheckbox>

            </div>
          </div>
          <div className={cn({
            'tab-group':true,
            'tab-group--active': tabGroups.otherTab.status
          })}>
            <div className={styles['tab-group--container']}>
              <h2>Прочее</h2>
              <p className={styles['tab-group--action']} onClick={()=>handleClickTab('otherTab')}>{tabGroups.otherTab.status ? 'Свернуть':'Развернуть'}</p>
            </div>
            <div className={cn(styles['form'], styles['tab-group--item'])}>
              прочее
            </div>
          </div>
        </div>
      </div>
      <div className={cn(styles['actions'],styles['actions--footer'])}>
        <div className={styles['actions--group-btn']}>
          <GxButton className={styles['btn--actions']}>Отмена</GxButton>
          <GxButton className={styles['btn--actions']}>Сохранить</GxButton>
        </div>
      </div>
    </div>
  );
};

export default CreateCertificate;
